import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import AppointmentFormModal from './AppointmentFormModal';

export const AdminJobForm = ({ appointment, onSuccess, onCancel }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const loadUsers = async () => {
    setLoading(true); setError('');
    try { const { data } = await axios.get(`${API}/admin/users`); setUsers(data); }
    catch { setError('Unable to load staff. Please retry before saving this job.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { loadUsers(); }, []);
  return <AppointmentFormModal appointment={appointment} users={users} onSuccess={onSuccess} onCancel={onCancel}
    staffLoading={loading} staffError={error} onRetryStaff={loadUsers} />;
};